// stores/appDomainStore.js
'use client';

import { mutate } from 'swr';

import { fleetApi } from '../api/axiosClient';

const getTzParam = () => `?tz=${Math.abs(new Date().getTimezoneOffset() / 60)}`;

export const revalidateAppDomainDataList = () => {
  mutate((key) => Array.isArray(key) && key[0] === '/app-domain/search');
};

// GET /app-domain/list
export const getAppDomainList = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const tzParam = getTzParam();
    const url = `/app-domain/list${query ? `?${query}&${tzParam.replace('?', '')}` : tzParam}`;
    const resp = await fleetApi.get(url);
    return resp?.data ?? null;
  } catch (err) {
    console.error('Failed to fetch app-domain list:', err);
    throw err;
  }
};

// POST /app-domain/new
export const createAppDomain = async (formData = {}) => {
  try {
    const response = await fleetApi.post(`/app-domain/new${getTzParam()}`, formData);

    if (response?.data?.status === false || response?.data?.code >= 400 || response?.data?.error) {
      throw { response: { data: response.data } };
    }
    revalidateAppDomainDataList();
    return response.data;
  } catch (err) {
    console.error('Error creating app-domain:', err);
    throw err;
  }
};

// PUT /app-domain/edit/{id}
export const updateAppDomain = async (id, formData = {}) => {
  if (id == null) throw new Error('id is required');
  try {
    const response = await fleetApi.put(`/app-domain/edit/${id}${getTzParam()}`, formData);

    if (response?.data?.status === false || response?.data?.code >= 400 || response?.data?.error) {
      throw { response: { data: response.data } };
    }
    revalidateAppDomainDataList();
    mutate(`/app-domain/${id}`);
    return response.data;
  } catch (err) {
    console.error('Error updating app-domain:', err);
    throw err;
  }
};
